import { createSlice } from "@reduxjs/toolkit";

const initialState = { quotes: [], quoteDetails: null };

export const quoteSlice = createSlice({
  name: "quote",
  initialState,
  reducers: {
    setQuoteList: (state = initialState, { payload }) => {
      return {
        ...state,
        quotes: payload,
      };
    },

    setQuoteDetails: (state = initialState, { payload }) => {
      return {
        ...state,
        quoteDetails: payload,
      };
    },

    updateQuote: (state = initialState, { payload }) => {
      return {
        ...state,
        quotes: state.quotes.map((quote) =>
          quote._id === payload._id ? payload : quote
        ),
      };
    },

    deleteQuote: (state = initialState, { payload }) => {
      return {
        ...state,
        quotes: state.quotes.filter((quote) => quote._id !== payload),
      };
    },
  },
});
